export const researchData = [
  {
    image: "/uploads/n1.png?2",
    gallery: [
      {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture_chls_1.png?2"},
    ],
    id: "1",
    tags: [
      { name: "CHLS", link: "https://www.hbku.edu.qa/en/chls" },
      { name: "Health ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Ayman Al Haj Zend",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/nady_el_hajj_07.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/chls/staff/ayman-al-haj-zen",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Nady El Hajj - CHLS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/nady_el_hajj_07.png?2",
        designation: "Assistant Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/chls/staff/nady-el-hajj",
      },
      {
        name: "Dr. George Hindy - QU",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Ali S Omrani - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],

    Funding: [{ name: "HMC- MRC", type: "External" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CHLS"],
    StartDate: "Dec-20",
    EndDate: "Jul-21",
    title:
      "Drug repurposing screen targeting the endothelial ACE2 for preventing cardiovascular complications in COVID-19 patients",
    ContentShort: [
      "Growing clinical evidence shows a significant correlation between the severity of COVID-19 symptoms and the incidence of cardiovascular complications (e.g., heart failure, thrombotic events). It emerges that endothelial dysfunction contributes to the initiation and propagation of acute respiratory failure in severe COVID-19 patients.",
    ],
    ContentFull: [
      "Growing clinical evidence shows a significant correlation between the severity of COVID-19 symptoms and the incidence of cardiovascular complications (e.g., heart failure, thrombotic events). It emerges that endothelial dysfunction contributes to the initiation and propagation of acute respiratory failure in severe COVID-19 patients. COVID-19 infects the host cells via the angiotensin-converting enzyme 2 (ACE2) receptor, which is highly expressed in the vascular endothelium. The binding of the COVID-19 spike protein to ACE2 causes a decrease of cellular ACE2 level.",
      "Reduced ACE2 activity leads to a widespread endothelial dysfunction manifested by enhanced vascular permeability and exacerbated thrombotic events, which take part in the pathology of severe cases of COVID-19 patients. In this proposal, we will develop a high content assay for evaluating endothelial function by measuring the nitric oxide production in human endothelial cells. ACE2 will be knock-downed by siRNA, thus recapitulating clinically the endothelial dysfunction associated with ACE2 downregulation in the severe cases of COVID-19. Using the optimized assay, we will conduct a high-throughput screen of an FDA-approved drug library to identify candidates that counteract the endothelial dysfunction caused by the ACE2 deficiency. The screen will generate novel drug(s) that can be repurposed to prevent the severe vascular complications in COVID-19 patients.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n2.png?2",
    gallery: [],
    id: "2",
    tags: [
      { name: "CHLS", link: "https://www.hbku.edu.qa/en/chls" },
      { name: "Health ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Borbala Mifsud",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/bori_mifsud_04.png?2",
        designation: "Assistant Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/chls/staff/borbala-mifsud",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Georges Nemer - CHLS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/dr._georges_nemer.png?2",
        designation: "Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/staff/georges-nemer",
      },
      {
        name: "Dr. Nady El Hajj - CHLS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/nady_el_hajj_07.png?2",
        designation: "Assistant Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/chls/staff/nady-el-hajj",
      },
      {
        name: "Dr. Ehsan Pourkarimi - CHLS",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/0.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/chls/staff/ehsan-pourkarimi",
      },
      {
        name: "Dr. Puthen Jithesh - CHLS",
        avator: "https://www.hbku.edu.qa/sites/default/files/styles/faculty_image_detail__416x416_/public/staff/jithesh_puthen.jpg?2",
        designation: "Associate Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/staff/puthen-veettil-jithesh",
      },
      {
        name: "Dr. Omar Albagha- QBRI",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/q.jpg?2",
        designation: "Acting Executive Director",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-omar-albagha",
      },
      {
        name: "Dr. Sharon Bout-Tabaku - Sidra",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Mamoun Elawad - Sidra",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Anthony Akobeng - Sidra",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Smar Al Emadi - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Mohammed Hammoudeh - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],

    Funding: [{ name: "QNRF - PPM", type: "External" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CHLS"],
    StartDate: "2020",
    EndDate: "2024",
    title: "Pharmacogenomics of TNF Inhibitors in Autoimmune Diseases",
    ContentShort: [
      "Autoimmune diseases are on the rise globally, and the largest increase is observed in highly developed countries. They contribute significantly to morbidity and mortality, posing a substantial burden on health care systems worldwide. Tumor necrosis factor-alpha (TNF) is a central pro-inflammatory cytokine whose upregulation plays an important role in the pathogenesis of many autoimmune diseases.",
    ],
    ContentFull: [
      "Autoimmune diseases are on the rise globally, and the largest increase is observed in highly developed countries. They contribute significantly to morbidity and mortality, posing a substantial burden on health care systems worldwide. Tumor necrosis factor-alpha (TNF) is a central pro-inflammatory cytokine whose upregulation plays an important role in the pathogenesis of many autoimmune diseases. TNF inhibitors (TNFi) are therefore widely used for a range of autoimmune conditions such as rheumatoid arthritis and Crohn's disease. However, response to treatment is variable among patients and up to 40% of patients do not improve with TNF inhibitor therapy. There are very few pharmacogenomics genome-wide association studies that could delineate clear links between genetic variants and treatment outcome, and these studies are especially lacking in Arab populations. We will establish a genetic correlation with response to treatment by recruiting patients with inflammatory arthritis and inflammatory bowel diseases and performing exome-wide association studies for the efficacy of TNF inhibitors.  Furthermore, we will assess the prevalence of both newly identified response-associated variants and those found in TNFi-response candidate genes in genomes sequenced by the Qatar Genome Programme, to understand the extent of their impact in the local population. Additionally, since autoimmune diseases are thought to be greatly influenced by the environment, we hypothesize that some of the variability is mediated by epigenetic factors, and we will perform an epigenome-wide association study to investigate the effect of differential DNA methylation on TNF inhibitor-response. Finally, we will validate the effect of variants on the functioning of the TNF signaling cascade in humanized C. elegans.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n3.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturedia1.jpg?2"},
           {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturedia2.jpg?2"},
      ],
    id: "3",
    tags: [
      { name: "QBRI", link: "https://www.hbku.edu.qa/en/qbri" },
      { name: "Health ", link: "" },
    ],
    pli: [
      {
        name: "",
        avator:
          "",
        designation: "",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Abdelilah Arredouani - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/abdelillah.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-abdelilah-arredouani",
      },
      {
        name: "Dr. Prasanna Kolatkar - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/prasanna-kolatkar.png?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-prasanna-r-kolatkar",
      },
      // {
      //   name: "Dr. Essam Abdelalim - QBRI",
      //   avator: "https://www.hbku.edu.qa/sites/default/files/staff/essam.jpg?2",
      //   designation: "Scientist",
      //   college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
      //   link: "https://www.hbku.edu.qa/en/qbri/staff/dr-essam-abdelalim",
      // },
      {
        name: "Dr. Omar El-Agnaf - QBRI",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/omaral.jpg?2",
        designation: "Principal Investigator",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-omar-el-agnaf",
      },
      {
        name: "Dr. Julie Decock - QBRI",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/juli.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-julie-decock",
      },
      // {
      //   name: "Dr. Alexandra Butler - QBRI",
      //   avator:
      //     "https://www.hbku.edu.qa/sites/default/files/staff/image0001.jpg?2",
      //   designation: "Principal Investigator",
      //   college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
      //   link: "https://www.hbku.edu.qa/en/qbri/staff/dr-alexandra-butler",
      // },
      {
        name: "Dr. Omar Albagha - QBRI",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/q.jpg?2",
        designation: "Acting Executive Director",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-omar-albagha",
      },
      {
        name: "Dr. Halima Bensmail - QCRI",
        // avator: "https://www.hbku.edu.qa/sites/default/files/staff/halima.jpg?2",
        avator: "",
        designation: "Principal Scientist and Joint associate Professor",
        college: [{name:"Qatar Computer Research Institute", link:'https://www.hbku.edu.qa/en/qcri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-halima-bensmail",
      },
      {
        name: "Dr. Rayaz Malik - WCMQ",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Jassim Al Suwaidi - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Ashfaq Shuaib - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Aeijaz Parray - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Mohamed Emara - QU",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],

    Funding: [{ name: "QBRI - Internal Grant Program", type: "Internal" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["QBRI"],
    StartDate: "2018",
    EndDate: "2021",
    title:
      "An Integrated Omic Approach to Identify Biomarkers for Type 2 Diabetes-associated Complications and Comorbidities",
    ContentShort: [
      "The prevalence of Type 2 Diabetes (T2D) in Qatar is among the highest in the world. T2D is a major health priority for Qatar and is associated with increased risk of debilitating co-morbidities such as cardiovascular disease (CVD), stroke and dementia.",
    ],
    ContentFull: [
      "The prevalence of Type 2 Diabetes (T2D) in Qatar is among the highest in the world. T2D is a major health priority for Qatar and is associated with increased risk of debilitating co-morbidities such as cardiovascular disease (CVD), stroke and dementia. CVD is the major cause of premature death of patients with T2D. There is an urgent need to identify biomarkers for diagnosis and risk of progression to increased severity of these co-morbidities.",
      "We will use an ‘omics approach to identify genomic, transcriptomic, proteomic and metabolomic biomarkers of CVD, stroke, dementia and their risk of progression in patients with and without diabetes.",
      "From project outcomes, we expect to identify new biomarkers to improve diagnosis and risk prediction of disease progression for CVD, stroke and dementia in patients with and without diabetes. The outcomes will advance our understanding of the pathogenesis of T2D co-morbidities and guide early-stage treatment for improved patient outcomes with an AI-developed precision medicine-based approach. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n4.png?2",
      gallery: [],
    id: "4",
    tags: [
      { name: "QBRI", link: "https://www.hbku.edu.qa/en/qbri" },
      { name: "Health ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Nehad Alajez",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/nehad_alajez_0_0.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-nehad-alajez",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Fares Al-Ejeh - QBRI",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/al-ejeh.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-fares-al-ejeh",
      },
      {
        name: "Dr. Mariam Al-Muftah - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/media/images/img-female-448x448.jpg?2",
        designation: "Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-mariam-al-muftah",
      },
      // {
      //   name: "Dr. Paul Thornalley",
      //   avator:
      //     "https://www.hbku.edu.qa/sites/default/files/staff/paul_thornalley_1.jpg?2",
      //   designation: "Director, Diabetes Research Center",
      //   college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
      //   link: "https://www.hbku.edu.qa/en/qbri/staff/dr-paul-j-thornalley",
      // },
      {
        name: "Dr. Julie Decock - QBRI",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/juli.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-julie-decock",
      },
      {
        name: "Dr. Hyung Goo Kim - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/hyung_goo_kim_1.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-hyung-goo-kim",
      },
      {
        name: "Dr. Abdelilah Arredouani - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/abdelillah.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-abdelilah-arredouani",
      },
      {
        name: "Dr. Omar El-Agnaf - QBRI ",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/omaral.jpg?2",
        designation: "Principal Investigator",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-omar-el-agnaf",
      },
    ],
    
    Funding: [{ name: "QBRI - Internal Grant Program", type: "Internal" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["QBRI"],
    StartDate: "2020",
    EndDate: "2023",
    title: "Diagnostic and predictive biomarkers in breast cancer",
    ContentShort: [
      "Although advances in cancer detection and therapies have significantly reduced breast cancer (BC) death rates, significant numbers of BC patients still develop resistance to therapies and almost all patients who develop metastatic disease face a very poor clinical outcome.",
    ],
    ContentFull: [
      "Although advances in cancer detection and therapies have significantly reduced breast cancer (BC) death rates, significant numbers of BC patients still develop resistance to therapies and almost all patients who develop metastatic disease face a very poor clinical outcome. Therefore, early detection of BC as well as appropriate selection of therapeutic regimen are essential for improvement of survival rate of BC patients. The goal of this project is to identify biomarkers for early diagnosis and improve the survival rate of BC patients in Qatar. To achieve this goal, a serious of experiment will be performed, genomics, transcriptomics, proteomics, metabolomics, and immunophenotyping analysis, to identify potential diagnostic and predictive biomarkers. Thus, upon successful completion of this project we expect to identify novel biomarkers which could potentially improve the clinical outcome of breast cancer patients in the MENA region and globally. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n5.png?2",
      gallery: [],
    id: "5",
    tags: [
      { name: "QBRI", link: "https://www.hbku.edu.qa/en/qbri" },
      { name: "Health ", link: "" },
    ],
    pli: [
      {
        name: "",
        avator:
          "",
        designation: "",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Abdelilah Arredouani - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/abdelillah.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-abdelilah-arredouani",
      },
      {
        name: "Dr. Lawrence Stanton - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/ah_5163_www.ahco_.productions.jpg?2",
        designation: "Director, Neurological Disorders Research Center",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/staff/lawrence-stanton",
      },
      {
        name: "Dr. Fouad Alshaban - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/foud-al-shaban.png?2",
        designation: "Senior Scientist ",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-fouad-alshaban",
      },
      {
        name: "Dr. Omar El-Agnaf - QBRI",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/omaral.jpg?2",
        designation: "Principal Investigator",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-omar-el-agnaf",
      },
      {
        name: "Dr. Julie Decock - QBRI",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/juli.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-julie-decock",
      },
      {
        name: "Dr. Abeer Al-Shammari - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/media/images/img-female-448x448.jpg?2",
        designation: "Research Fellow",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-abeer-al-shammari",
      },
      {
        name: "Dr. Hyung Goo Kim - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/hyung_goo_kim_1.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-hyung-goo-kim",
      },
      {
        name: "Dr. Nehad Alajez - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/nehad_alajez_0_0.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-nehad-alajez",
      },
    ],
    
    Funding: [{ name: "QBRI - Internal Grant Program", type: "Internal" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["QBRI"],
    StartDate: "2018",
    EndDate: "2021",
    title:
      "Identifying Potential Molecular Biomarkers for Autism Spectrum Disorder. ",
    ContentShort: [
      "Autism spectrum disorder (ASD) is a complex neurodevelopmental disorder characterized by core symptoms that include social interaction deficits and language difficulties.",
    ],
    ContentFull: [
      "Autism spectrum disorder (ASD) is a complex neurodevelopmental disorder characterized by core symptoms that include social interaction deficits and language difficulties. Due to the complexity of ASD, many endeavors have failed to identify reliable ASD biomarkers. Therefore, the primary goal of the present proposal is to identify molecular biomarkers for early diagnosis of ASD and to enhance our understanding of the underlying mechanisms of ASD pathophysiology. A blend of Omic approaches will be applied to blood collected from a large, homogenous, and well phenotyped cohort of ASD patients. Next generation sequencing technologies including whole genome sequencing is used to identify gene variants associated with ASD and controls. Proteomics, using the Somalogic platform and Sengenics Immunome Protein Array also used to screen blood samples to identify novel biomarkers (proteins and autoantibodies). These panel of biomarkers can be translated into an ELISA assay or to any other sensitive platform if needed. Metabolomics profiling will also be used to screen blood samples to identify novel metabolomics signatures of ASD. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n6.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictureqbri01.png?2"},
      ],
    id: "6",
    tags: [
      { name: "QBRI", link: "https://www.hbku.edu.qa/en/qbri" },
      { name: "Health ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Julie Decock ",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/juli.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-julie-decock",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Omar El-Agnaf - QBRI ",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/omaral.jpg?2",
        designation: "Principal Investigator",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-omar-el-agnaf",
      },
      // {
      //   name: "Dr. Paul Thornalley",
      //   avator:
      //     "https://www.hbku.edu.qa/sites/default/files/staff/paul_thornalley_1.jpg?2",
      //   designation: "Director, Diabetes Research Center",
      //   college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
      //   link: "https://www.hbku.edu.qa/en/qbri/staff/dr-paul-j-thornalley",
      // },
      {
        name: "Dr. Hyung Goo Kim - QBRI ",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/hyung_goo_kim_1.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-hyung-goo-kim",
      },
      {
        name: "Dr. Prasanna Kolatkar - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/prasanna-kolatkar.png?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-prasanna-r-kolatkar",
      },
      // {
      //   name: "Dr. Alexandra Butler - QBRI",
      //   avator:
      //     "https://www.hbku.edu.qa/sites/default/files/staff/image0001.jpg?2",
      //   designation: "Principal Investigator",
      //   college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
      //   link: "https://www.hbku.edu.qa/en/qbri/staff/dr-alexandra-butler",
      // },
      {
        name: "Dr. Abdelilah Arredouani - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/abdelillah.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-abdelilah-arredouani",
      },
      // {
      //   name: "Dr. Sara Abdulla - QBRI ",
      //   avator:
      //     "https://www.hbku.edu.qa/sites/default/files/staff/sara_abdulla_0_0.jpg?2",
      //   designation: "Research Fellow",
      //   college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
      //   link: "https://www.hbku.edu.qa/en/staff/dr-sara-abdulla",
      // },
      {
        name: "Dr. Heba Al-Siddiqi - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/heba_al-siddiqi_1_0.jpg?2",
        designation: "Research Fellow",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-heba-h-al-siddiqi",
      },
      {
        name: "Dr. Shahryar Khattak - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/shahryar-khattak.png?2",
        designation: "Core Manager – Stem Cell and Genome Engineering",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-shahryar-khattak",
      },
      {
        name: "Dr. Nehad Alajez - QBRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/nehad_alajez_0_0.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-nehad-alajez",
      },
      {
        name: "Dr. Yongsoo Park - QBRI ",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/yongsoo_park_0.png?2",
        designation: "Scientist",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-yongsoo-park",
      },
      {
        name: "Dr. Khalid Ouararhni - QBRI ",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/khalid-ouararhni.png?2",
        designation: "Core Manager – Genomics and Genome Technology",
        college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
        link: "https://www.hbku.edu.qa/en/qbri/staff/dr-khalid-ouararhni",
      },
    ],
 
    Funding: [{ name: "QBRI - Internal Grant Program", type: "Internal" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["QBRI"],
    StartDate: "2020",
    EndDate: "2023",
    title: "Integrative, translational research against COVID-19",
    ContentShort: [
      "COVID-19 has a huge impact on health and the economy. The immediate goal of this proposal is to create a substantive clinical impact on the current COVID-19 situation and, in the long-term, to foster preparedness in Qatar for any future resurgence of SARS-CoV-2 or other infections.",
    ],
    ContentFull: [
      "COVID-19 has a huge impact on health and the economy. The immediate goal of this proposal is to create a substantive clinical impact on the current COVID-19 situation and, in the long-term, to foster preparedness in Qatar for any future resurgence of SARS-CoV-2 or other infections. The program will integrate patient-based and in vitro-based studies. Furthermore, we will apply a multi-disciplinary approach with dynamic interactions across experienced research teams at QBRI and with clinicians and researchers across Qatar. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n8.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture11_dd.png?2"},
      ],
    id: "8",
    tags: [
      { name: "CHSS", link: "https://www.hbku.edu.qa/en/chss" },
      { name: "Social Sciences", link: "" },
      { name: "Humanities", link: "" },
      { name: "Migration", link: "" },
      { name: "Health", link: "" },
      { name: "Digital cultures", link: "" },
    ],
    pli: [
      {
        name: "Dr. Sophie Richter-Devroe",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/dr.-sophie-ritcher_2.jpg?2",
        designation:
          "Associate Professor in Master of Arts in Women, Society and Development",
        college: [{name:"College of Humanities and Social Sciences", link:'https://www.hbku.edu.qa/en/chss'}],
        link: "https://www.hbku.edu.qa/en/chss/staff/sophie-richter-devroe",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. George Mikros - CHSS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/dr-george-mikros_1.jpg?2",
        designation:
          "Professor in Master of Arts in Digital Humanities and Societies",
        college: [{name:"College of Humanities and Social Sciences", link:'https://www.hbku.edu.qa/en/chss'}],
        link: "https://www.hbku.edu.qa/en/chss/staff/george-mikros",
      },

      {
        name: "Dr. Ingmar Weber - QCRI ",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/ingmar_weber_01.jpg?2",
        designation: "Research Director",
        college: [{name:"Qatar Computing Research Institute", link:'https://www.hbku.edu.qa/en/qcri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-ingmar-weber",
      },
    ],
   
    Funding: [{ name: "Thematic Grants", type: "Internal" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CHSS"],
    StartDate: "Jan-21",
    EndDate: "Dec-21",
    title: "Forced Migration, Digital Technology and Health",
    ContentShort: [
      "This project proposes an interdisciplinary, innovative and ethnographically rich study of Syrian refugees in Italy and Greece.",
    ],
    ContentFull: [
      "This project proposes an interdisciplinary, innovative and ethnographically rich study of Syrian refugees in Italy and Greece. Combining ethnographic fieldwork with digital data collection, we examine the crucial, but often neglected, links between health and digital technology in the context of forced migration and displacement. ",
      "Syrians have faced severe health challenges in Italy and Greece. Faced with poor service provision, inadequate reception facilities, lack of benefits, employment difficulties and insecure legal status, the COVID-19 health pandemic further increased their precariousness. The digital realm is crucial in this context: refugees rely on digital technology in their migration and health strategies, and service providers, too, use digital communication methods.",
      "Recognizing the central position that health and digital technology occupy in refugees' lived experiences of migration, we ask: What is the status and context of health provision to Syrian refugees in Italy and Greece? How does the biopolitical nexus of health and technology shape refugees’ experiences and strategies of migration and well-being? How can health services for refugees be improved?",
      "Beyond advancing academic knowledge on the topic, our project’s findings will contribute to policy, humanitarian and developmental praxis by advancing the debate on health inequalities and social justice for refugees and migrants.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n9.png?2",
      gallery: [],
    id: "9",
    tags: [
      { name: "CHSS", link: "https://www.hbku.edu.qa/en/chss" },
      { name: "Digital Humanities", link: "" },
      { name: "Misinformation", link: "" },
      { name: "Social Media Analysis", link: "" },
      { name: "Computational Linguistics  ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Wajdi Zaghouani ",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/wajdi.jpg?2",
        designation:
          "Assistant Professor in Master of Arts in Digital Humanities and Societies",
        college: [{name:"College of Humanities and Social Sciences", link:'https://www.hbku.edu.qa/en/chss'}],
        link: "https://www.hbku.edu.qa/en/chss/staff/wajdi-zaghouani",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. George Mikros - CHSS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/dr-george-mikros_1.jpg?2",
        designation:
          "Professor in Master of Arts in Digital Humanities and Societies",
        college: [{name:"College of Humanities and Social Sciences", link:'https://www.hbku.edu.qa/en/chss'}],
        link: "https://www.hbku.edu.qa/en/chss/staff/george-mikros",
      },
      {
        name: "Dr. Marc Owen Jones - CHSS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/marc-own.jpg?2",
        designation:
          "Assistant Professor in Master of Arts in Digital Humanities and Societies",
        college: [{name:"College of Humanities and Social Sciences", link:'https://www.hbku.edu.qa/en/chss'}],
        link: "https://www.hbku.edu.qa/en/chss/staff/marc-owen-jones",
      },
    ],
 
    Funding: [{ name: "Innovation Grants", type: "Internal" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CHSS"],
    StartDate: "Jan-21",
    EndDate: "May-21",
    title: "COVID-19 Misinformation and Social Networks Analysis in Qatar",
    ContentShort: [
      "In this pilot project, we plan to collect and study the social media misinformation networks, myths, and rumors also known by the World Health Organizations as Misinformation Infodemic [2] related to the COVID-19 in Qatar [9].",
    ],
    ContentFull: [
      "In this pilot project, we plan to collect and study the social media misinformation networks, myths, and rumors also known by the World Health Organizations as Misinformation Infodemic [2] related to the COVID-19 in Qatar [9]. We will focus on the Arabic language posts and we will also collect some related posts in English as well.",
      "We will start by collecting a large dataset from various Social Media platforms in Qatar such as Twitter, Instagram, and Facebook. Later on, We will organize and annotate the data by topics ( e.g Vaccine, home remedy myths, new treatment, death rates, lockdown….). Once the data organized by the infodemic topics, we will proceed with the analysis of the COVID-19 misformation and rumors shared in order to trace the origin of the misinformation using social network analysis methods [3] this will allow us to reveal the origin of the shared Infodemics",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n10.png?2",
      gallery: [
          
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturecis_1.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturecis_2.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturecis_3.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturecis_4.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturecis_5.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturecis_6.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturecis_7.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturecis_8.jpg?2"},
      ],
    id: "10",
    tags: [
      { name: "CIS", link: "https://www.hbku.edu.qa/en/cis" },
      { name: "Islamic Studies ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Mohammed Ghaly",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/profileimage_drmghaly.jpg?2",
        designation: "Professor of Islam and Biomedical Ethics",
        college: [{name:"College of Islamic Studies", link:'https://www.hbku.edu.qa/en/cis'}],
        link: "https://www.hbku.edu.qa/en/cis/staff/mohammed-ghaly",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Muetaz Alkhatib - CIS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/profileimage_drmalkhatib_0.jpg?2",
        designation: "Associate Professor of Methodology and Ethics",
        college: [{name:"College of Islamic Studies", link:'https://www.hbku.edu.qa/en/cis'}],
        link: "https://www.hbku.edu.qa/en/cis/staff/mutaz-alkhatib",
      },
      {
        name: "Dr. Abdul badi Abu-Samra - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Khalid Alali - QU",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Aasim Padela - University of Chicago",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Ebrahim Moosa - University of Notre Dame",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
  
    Funding: [{ name: "QNRF - NPRP8", type: "External" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CIS"],
    StartDate: "Sep-16",
    EndDate: "Mar-20",
    title:
      "Indigenizing Genomics in the Gulf Region (IGGR): The Missing Islamic Bioethical Discourse",
    ContentShort: [
      "The Gulf region showed a keen interest to join this genomic revolution. In 2013, HH Sheikha Moza bint Nasser launched the Qatar Genome Project (QGP).",
    ],
    ContentFull: [
      "The Gulf region showed a keen interest to join this genomic revolution. In 2013, HH Sheikha Moza bint Nasser launched the Qatar Genome Project (QGP). What is absent in the Gulf region is a credible knowledge-base that would pair the scientific research with cutting-edge research in Islamic ethics. Indigenizing Genomics in the Gulf Region (IGGR) is research project that aspires to become a leading initiative dedicated to the ethical implications and opportunities in Islamic discourses.",
      "The IGGR will accomplish its aims by developing a multi-dimensional Islamic bioethical research. It will be rooted in the Islamic religio-ethical tradition and will pave the way for dynamic conversation with other global ethical traditions. The IGGR will seek to find synergies with the Qatar Genome Project and similar initiatives in the region in order to optimize the research outcomes and will also examine the impact of its results on drafting Qatari laws on genomics besides its relevance for developing informed and ethical policies in this field in Qatar, the Gulf region and beyond. The IGGR will serve as a model for dialogue between science and Islam by creating a set of methods, questions and conceptual vocabulary to facilitate bringing together these sources of knowledge.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n11.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c1.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c2.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c3.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c4.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c5.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c6.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c7.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c8.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c9.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c10.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c11.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1c12.png?2"},
          
      ],
    id: "11",
    tags: [
      { name: "CIS", link: "https://www.hbku.edu.qa/en/cis" },
      { name: "Islamic Finance", link: "" },
      { name: "Fintach", link: "" },
      { name: "Sustainable finance and social sciences", link: "" },
    ],
    pli: [
      {
        name:
          "Islamic Finance & Economy Program and Center for Islamic Economics and Finance",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Ahmed Faruk Aysan - CIS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/profileimage_draaysan.jpg?2",
        designation: "Program Coordinator",
        college: [{name:"College of Islamic Studies", link:'https://www.hbku.edu.qa/en/cis'}],
        link: "https://www.hbku.edu.qa/en/staff/ahmet-faruk-aysan",
      },
      {
        name: "Dr. Syed Nazim Ali - CIS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/profileimage_snali.jpg?2",
        designation:
          "Director of the Research Division and Director of the Center for Islamic Economics and Finance",
        college: [{name:"College of Islamic Studies", link:'https://www.hbku.edu.qa/en/cis'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-syed-nazim-ali",
      },
      {
        name: "Dr. Dalal Aassouli - CIS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/profile_picture_dalalaassouli_0.jpg?2",
        designation: "Assistant Professor of Islamic Finance",
        college: [{name:"College of Islamic Studies", link:'https://www.hbku.edu.qa/en/cis'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-dalal-aassouli",
      },
    ],

    Funding: [{ name: "Qatar Financial Center", type: "External" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CIS"],
    StartDate: "Jan-20",
    EndDate: "Dec-21",
    title:
      "Sustainability and the FinTech Revolution: Implications for Islamic Finance and Economy in the Post Pandemic Era",
    ContentShort: [
      "This 3-year project will be undertaken by the Islamic Finance and Economy Program, with the support of Center for Islamic Economics and Finance (CIEF), College of Islamic Studies (CIS), Hamad Bin Khalifa University (HBKU), and in partnership with Qatar Financial Centre (QFC) Authority.",
    ],
    ContentFull: [
      "This 3-year project will be undertaken by the Islamic Finance and Economy Program, with the support of Center for Islamic Economics and Finance (CIEF), College of Islamic Studies (CIS), Hamad Bin Khalifa University (HBKU), and in partnership with Qatar Financial Centre (QFC) Authority. All in all, the project also aims to bring the relevant stakeholders in Qatar and worldwide together though conferences and workshops to expose their existing capacities and competencies in Fintech and Sustainable finance. In stages, this project will first increase the awareness about the most recent developments in Fintech and sustainable finance after the Covid-19 shock globally. However, the project does not end there and by design the project aims to offer policy and business strategies to act on. Hence, the project aims to contribute the implementation of strategies highlighted in Qatar National Vision 2030. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n12.png?2",
      gallery: [
           {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture_cis_3.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture_cis_1_3.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1ciss.png?2"},
           {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1ciss3.png?2"},
      ],
    id: "12",
    tags: [
      { name: "CIS", link: "https://www.hbku.edu.qa/en/cis" },
      { name: "Social Sciences ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Evren Tok",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/dr_etok_0.jpg?2",
        designation:
          "Assistant Dean of Innovation and Community Engagement and Associate Professor of Islam and Global Affairs",
        college: [{name:"College of Islamic Studies", link:'https://www.hbku.edu.qa/en/cis'}],
        link: "https://www.hbku.edu.qa/en/cis/staff/mohamed-evren-tok",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Muammer Koc - CSE",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_muammer_koc.jpg?2",
        designation: "Founding Professor and Head of Sustainability Division",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/muammer-koc",
      },
      {
        name: "Dr. Rabia Naguib - Doha Institute",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Leslie Pal - CPP",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/1-_cpp_dean_-_dr._leslie_a._pal.jpg?2",
        designation: "Dean",
        college: [{name:"College of Public Policy", link:'https://www.hbku.edu.qa/en/cpp'}],
        link: "https://www.hbku.edu.qa/en/cpp/staff/leslie-pal",
      },
    ],

    Funding: [{ name: "QNRF- NPRP10", type: "External" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CIS"],
    StartDate: "Jan-19",
    EndDate: "Jan-22",
    title: "Localizing Entrepreneurship Education in Qatar",
    ContentShort: [
      "This three-year project will be undertaken by Hamad bin Khalifa University (HBKU), in collaboration with its College of Islamic Studies (CIS), College of Law and Public Policy (CLPP) and its College of Science and Engineering (CES - Sustainability Graduate Program), and in partnership with Doha Institute for Graduate Studies and the Carleton University. ",
    ],
    ContentFull: [
      "This three-year project will be undertaken by Hamad bin Khalifa University (HBKU), in collaboration with its College of Islamic Studies (CIS), College of Law and Public Policy (CLPP) and its College of Science and Engineering (CES - Sustainability Graduate Program), and in partnership with Doha Institute for Graduate Studies and the Carleton University. External partners will include the World Innovation Summit for Education (WISE) the Qatar Development Bank (QDB), Qatar Business Incubation Center (QBIC), INJAZ Qatar, Qatar Chamber, Qatar Finance and Business Academy (QFBA) and Silatech. The project develops and deliver a local entrepreneurship platform, based on local needs, strengths and traditions, to train and grow start-up entrepreneurs in Qatar. It will directly facilitate the expansion of a culture of entrepreneurship, in line with the Social Sciences, Arts and Humanities pillar of the Qatar National Vision (QNV) 2030. The project will harness the financial and in-kind resources of its partners, all locally based and steeped in local conditions, to build supportive environments and capacity building tools to nurture and challenge entrepreneurship. However, entrepreneurship needs a compass of morals to be more than just profit-making, and to play a transformational role not only a transactional one. The research will highlight this dimension and integrate it into all its deliverables. It is crucial to balance modernization and tradition in fast-moving economies, such as Qatar. Searching for the moral basis of entrepreneurship in this regard could help identify new articulations between globalization and localization; social cohesion and capitalism; culture and markets; and finally between modernization and tradition. This project will help entrepreneurs understand that their initiatives must balance globalization and localization, social cohesion and capitalism, culture and markets. This balance is crucial to Qatar’s transition to a diversified knowledge-based economy, encouraging global competitiveness while preserving traditional values and strengths.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n13.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/clpicture1.jpg?2"},
      ],
    id: "13",
    tags: [
      { name: "College of Law", link: "https://www.hbku.edu.qa/en/cl" },
      { name: "Envrionment", link: "" },
      { name: "Sustainable Development Humanity ", link: "" },
      { name: "Social Sciences", link: "" },
      { name: "Energy", link: "" },
    ],
    pli: [
      {
        name: "Dr. Damilola S. Olawuyi",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_damilola_s._olawuyi.jpg?2",
        designation: "Associate Dean for Research",
        college: [{name:"College of Law", link:'https://www.hbku.edu.qa/en/cl'}],
        link: "https://www.hbku.edu.qa/en/cl/staff/damilola-s-olawuyi",
      },
    ],
    ProjectTeams: [],
    Funding: [
      {
        name: "QNRF- CWSP - United Nations Enrionment Grants Program",
        type: "External",
      },
    ],
    Type: ["Exellence", "Innovation"],
    Entity: ["CL"],
    StartDate: "Oct-20",
    EndDate: "Dec-21",
    title:
      "Environmental Law Education for Sustainable Development in Qatar and the Middle East and North African (MENA) region: Methodologies and Pedagogical Approaches for Effective Delivery",
    ContentShort: [
      "This project is in partnership with the United Nations Environment Program (UNEP). ",
    ],
    ContentFull: [
      "This project is in partnership with the United Nations Environment Program (UNEP). It aims to bring together environmental educators, researchers, trainers, and practitioners dedicated to advancing the teaching and practice of environmental, climate change and sustainable development law and policy in Qatar and across the MENA region. The project has been developed to address a perceived gap in the development and refinement of current environmental law and policy curricula, and the design of innovative pedagogical methods that could enhance delivery of substantive environmental law and policy knowledge to students. It also aims to enhance participatory engagement and active executive education on environment and the SDGs for leaders in public, private and financial spheres.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n14.png?2",
      gallery: [],
    id: "14",
    tags: [
      { name: "College of Law", link: "https://www.hbku.edu.qa/en/cl" },
      { name: "AI", link: "" },
      { name: "Precision Medicine", link: "" },
      { name: "Law", link: "" },
      { name: "Health and Life Sciences", link: "" },
      { name: "Computer Science", link: "" },
      { name: "Islamic Studies", link: "" },
    ],
    pli: [
      {
        name: "Dr. Barry Solaiman ",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/2-_barry_solaiman.jpg?2",
        designation: "Assistant Dean of Students",
        college: [{name:"College of Law", link:'https://www.hbku.edu.qa/en/cl'}],
        link: "https://www.hbku.edu.qa/en/cl/staff/barry-solaiman",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Said Ismail - CHLS",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/al8i1072ii.jpg?2",
        designation: "Adjunct Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/staff/said-ismail",
      },
      {
        name: "Dr. Mohammed Ghaly - CIS",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/profileimage_drmghaly.jpg?2",
        designation: "Professor of Islam and Biomedical Ethics",
        college: [{name:"College of Islamic Studies", link:'https://www.hbku.edu.qa/en/cis'}],
        link: "https://www.hbku.edu.qa/en/cis/staff/mohammed-ghaly",
      },
      {
        name: "Dr. Mowafa Househ - CSE",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/1-_mowafa_househ.jpg?2",
        designation: "Associate Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/mowafa-househ",
      },
      {
        name: "Dr. Borbala Mifsud",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/bori_mifsud_04.png?2",
        designation: "Assistant Professor",
        college: [{name:"College of Health and Life Sciences", link:'https://www.hbku.edu.qa/en/chls'}],
        link: "https://www.hbku.edu.qa/en/chls/staff/borbala-mifsud",
      },
      // {
      //   name: "Dr. Paul Thornalley",
      //   avator:
      //     "https://www.hbku.edu.qa/sites/default/files/staff/paul_thornalley_1.jpg?2",
      //   designation: "Director, Diabetes Research Center",
      //   college: [{name:"Qatar Biomedical Research Institute", link:'https://www.hbku.edu.qa/en/qbri'}],
      //   link: "https://www.hbku.edu.qa/en/qbri/staff/dr-paul-j-thornalley",
      // },
    ],
 
    Funding: [{ name: "Thematic Grants", type: "Internal" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CL"],
    StartDate: "Jan-21",
    EndDate: "Dec-22",
    title:
      "Artificial Intelligence for Precision Medicine & Health Technologies: Developing a Regulatory Framework for Qatar and the Middle East",
    ContentShort: [
      "This project will develop a code of practice, guidelines and a certification process for the use of artificial intelligence (AI) technology in health research, with a substantial focus on AI used for precision medicine.",
    ],
    ContentFull: [
      "This project will develop a code of practice, guidelines and a certification process for the use of artificial intelligence (AI) technology in health research, with a substantial focus on AI used for precision medicine. The code of practice and guidelines will set the benchmark for Qatar and the Middle East, bringing Qatar to the international table. At the same time, the certification process will provide a significant mark of credibility for local research, helping to disseminate it internationally. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n15.png?2",
      gallery: [],
    id: "15",
    tags: [
      { name: "College of Law", link: "https://www.hbku.edu.qa/en/cl" },
      { name: "International Trade Law", link: "" },
      { name: "Innovation", link: "" },
    ],
    pli: [
      {
        name: "Dr. Alexander Ezenagu",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/1-_alexander_p._ezenagu.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Law", link:'https://www.hbku.edu.qa/en/cl'}],
        link: "https://www.hbku.edu.qa/en/cl/staff/alexander-p-ezenagu",
      },
    ],
    ProjectTeams: [
      {
        name: "Prof. Georgios Dimitropoulos - College of Law",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/4-_georgios_dimitropoulos.jpg?2",
        designation: "Associate Dean for Academic Affairs",
        college: [{name:"College of Law", link:'https://www.hbku.edu.qa/en/cl'}],
        link: "https://www.hbku.edu.qa/en/cl/staff/georgios-dimitropoulos",
      },
      {
        name: "Dr. Onyeka Osuji - Essex University",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Mohammed Alshaleel - Essex University",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],

    Funding: [{ name: "QNRF", type: "External" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CL"],
    StartDate: "Nov-20",
    EndDate: "Oct-21",
    title:
      "Digitalising International Trade Finance Process: Interrelationships, Constraints and Opportunities and Perspectives",
    ContentShort: [
      "The Gulf region showed a keen interest to join this genomic revolution. In 2013, HH Sheikha Moza bint Nasser launched the Qatar Genome Project (QGP).",
    ],
    ContentFull: [
      "The present trade finance process seems unsuited for the contemporary world with difficulties arising, for example, from the mostly paper-based nature of trade documents and the need for checking regulatory and contractual compliance, in addition to curbing illicit financial flows in trade processes. A typical end-to-end international trade finance transaction includes several parties- such as buyers, sellers, banks, custom authorities, freight forwarders and insurance agency- and sets of documents. Some efforts to digitalise trade finance, such as bank payment obligation (BPO) and MT798, appear to have fallen short due to a limited focus on narrow parts of the process when a holistic approach is necessary. The ongoing Covid-19 pandemic equally demonstrates that this is a high priority project going by its adverse impact on the trade finance process.",
      "This international conference is a major component of a research project that aims to make a pioneering attempt at undertaking a comprehensive study of the digitalisation of the entire process of trade finance. Within the aim of investigating the possibility of digitalising end-to-end trade finance process, the main goals of the international conference are: (1) to develop a multi-disciplinary dialogue between various stakeholders, involving practitioners, policymakers, regulators and researchers; and (2) to discuss the key issues and problems from different perspectives and articulate tentative proposals for remedying them.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n16.png?2",
      gallery: [],
    id: "16",
    tags: [
      { name: "College of Law", link: "https://www.hbku.edu.qa/en/cl" },
      { name: "Energy", link: "" },
      { name: "Envrionment", link: "" },
      { name: "Sustainable Development Humanity", link: "" },
      { name: "Social Sciences", link: "" },
    ],
    pli: [
      {
         name: "Dr. Damilola S. Olawuyi - College of Law",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_damilola_s._olawuyi.jpg?2",
        designation: "Associate Dean for Research",
        college: [{name:"College of Law", link:'https://www.hbku.edu.qa/en/cl'}],
        link: "https://www.hbku.edu.qa/en/cl/staff/damilola-s-olawuyi",
        addExtraClass:'d-none'
      },
        {
        name: "Prof. Rory Miller, Georgetown University",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Damilola S. Olawuyi - College of Law",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_damilola_s._olawuyi.jpg?2",
        designation: "Associate Dean for Research",
        college: [{name:"College of Law", link:'https://www.hbku.edu.qa/en/cl'}],
        link: "https://www.hbku.edu.qa/en/cl/staff/damilola-s-olawuyi",
      },
    ],

    Funding: [{ name: "QNRF- NPRP-12S", type: "External" }],
    Type: ["Exellence", "Innovation"],
    Entity: ["CL"],
    StartDate: "Oct-20",
    EndDate: "Dec-20",
    title:
      "Managing National Security Risk during and after the Blockade: Strategic Challenges and Opportunities for Qatar’s Energy Sector",
    ContentShort: [
      "The Gulf region showed a keen interest to join this genomic revolution. In 2013, HH Sheikha Moza bint Nasser launched the Qatar Genome Project (QGP).",
    ],
    ContentFull: [
      "This project examines Qatar’s evolving energy policies in light of the Gulf Crisis.This project examines the challenges and opportunities that Qatar’s energy sector has encountered in managing national security risk during and after the blockade launched against it in June 2017 and how the evolving strategic environment will result in new challenges and opportunities in the future. No such comprehensive study of the Qatari energy sector currently exists.",
      "Steeped in a commitment to applied social science research and rigorous analytical analysis, the project will identify national security challenges and opportunities that policymakers are likely to encounter in the future as they engage with key regional and international energy partners unilaterally and through bilateral and multilateral frameworks. It will then propose a menu of strategic, security, legal and regulatory options available to Qatar in the future to enable it to manage those challenges and to capitalize on those opportunities.",
      "The project is undertaken in collaboration with Georgetown University in Qatar (GUQ), the General Retirement and Social Insurance Authority (GRSIA) of the State of Qatar, the University of Warwick (United Kingdom), and Sakarya University (Turkey). Apart from the GRSIA, the project has other important end-users: The Amiri Diwan of the State of Qatar; QatarGas; and The Abdullah Bin Hamad Al-Attiyah International Foundation for Energy and Sustainable Development.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n17.png?2",
      gallery: [],
    id: "17",
    tags: [
      { name: "College of Law", link: "https://www.hbku.edu.qa/en/cl" },
      { name: "AI", link: "" },
      { name: "Cybersecurity", link: "" },
      { name: "Law", link: "" },
      { name: "Regulation ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Roberto Di Pietro, CSE",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_roberto_di_pietro.jpg?2",
        designation: "Full Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/roberto-di-pietro",
      },
    ],
    ProjectTeams: [
      {
        name: "Prof. Georgios Dimitropoulos - College of Law",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/4-_georgios_dimitropoulos.jpg?2",
        designation: "Associate Dean for Academic Affairs",
        college: [{name:"College of Law", link:'https://www.hbku.edu.qa/en/cl'}],
        link: "https://www.hbku.edu.qa/en/cl/staff/georgios-dimitropoulos",
      },
    ],

    Funding: [{ name: "Thematic Grants", type: "Internal" }],
    Type: ["Artificial Intelligence"],
    Entity: ["CL"],
    StartDate: "Jan-21",
    EndDate: "Dec-22",
    title: "Blending AI and Regulation for Lawful Anonymous WEB Navigation",
    ContentShort: [
      "Nowadays, more and more applications available in digital markets, such as Play-store and Apple Store, hide other software within them, often without the user's knowledge. ",
    ],
    ContentFull: [
      "Nowadays, more and more applications available in digital markets, such as Play-store and Apple Store, hide other software within them, often without the user's knowledge. Consequently, when users download an application, they may simultaneously download unrequired software, i.e., hidden services, which are not useful and possibly harmful – from both a technical and legal perspective. Among these hidden services, a new type of HTTP proxy, called Residential Proxy (RESIP), has been spreading recently. Once installed, a RESIP service transforms the user's device into an exit point of a VPN network. Users who install an application that contains a hidden RESIP service unknowingly become responsible for the web traffic generated by the RESIP network, potentially becoming accountable for cyber-crimes committed by third parties. ",
      "This project aims to address the spread of unauthorized internet proxy services by providing adequate technological and legal countermeasures, as well as define policy guidelines to promote the appropriate use of anonymous internet browsing technologies. From a technical point of view, the primary objective is to investigate the functioning of RESIP proxies, also providing an AI-based detection mechanism. From the legal perspective, the goal is to provide guidelines to stem the malicious spread of proxy services, avoiding legal consequences for unwitting users.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n18.png?2",
      gallery: [],
    id: "18",
    tags: [
      { name: "CPP", link: "https://www.hbku.edu.qa/en/cpp" },
      { name: "Policy", link: "" },
      { name: "Law", link: "" },
      { name: "Land", link: "" },
      { name: "Rights", link: "" },
      { name: "Food Security", link: "" },
      { name: "Livelihoods", link: "" },
      { name: "Foreign Direct Investment ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Logan Cochrane",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/1-_logan_cochrane.jpg?2",
        designation: "Associate Professor",
        college: [{name:"College of Public Policy", link:'https://www.hbku.edu.qa/en/cpp'}],
        link: "https://www.hbku.edu.qa/en/staff/logan-cochrane",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Nathan Andrews - UNBC, Canada",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],

    Funding: [{ name: "SSHRC, Canada", type: "External" }],
    Type: ["Social Progress"],
    Entity: ["CPP"],
    StartDate: "2019",
    EndDate: "2021",
    title:
      "The Global Land Rush, Inequalities and Livelihoods: Enabling Environments for Strengthening Food Security in Ethiopia and Ghana",
    ContentShort: [
      "Over 800 million people face food insecurity around the world, a figure that has risen in recent years. One of the biggest changes in the last decade to the food and agriculture sectors is the rise of foreign investment. ",
    ],
    ContentFull: [
      "Over 800 million people face food insecurity around the world, a figure that has risen in recent years. One of the biggest changes in the last decade to the food and agriculture sectors is the rise of foreign investment. Many governments are optimistic about how this may contribute to improved livelihoods and food security. On the other hand, non-governmental organizations are pessimistic and suggest these changes foster inequalities and harm livelihoods. Africa has been central to a lot of this foreign investment. While much research has been conducted, limited academic research takes an interdisciplinary perspective to evaluate the intersections between private investment, livelihoods, inequalities and food security. What is available often draws upon singular case studies. We contribute to the literature, and address this knowledge gap, by analyzing and comparing six case studies from two countries: Ethiopia and Ghana. The core research question guiding this project is: What are the legal, policy and regulatory regimes and processes that form an enabling environment for the private sector to strengthen food security, improve livelihoods and promote economic growth for all?",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n19.png?2",
      gallery: [],
    id: "19",
    tags: [
      { name: "CPP", link: "https://www.hbku.edu.qa/en/cpp" },
      { name: "Social Policy", link: "" },
      { name: "Social Sciences", link: "" },
      { name: "Family Studies", link: "" },
    ],
    pli: [
      {
        name: "Dr. Anis Ben Brik",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/dr_anis.jpg?2",
        designation: "Associate Professor",
        college: [{name:"College of Public Policy", link:'https://www.hbku.edu.qa/en/cpp'}],
        link: "https://www.hbku.edu.qa/en/cpp/staff/dr-anis-ben-brik",
      },
    ],
    ProjectTeams: [
      {
        name: "Natalie Williams - University of Nebraska (US)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Spencer James - Brigham Young University (US)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Annette Ptassek - IFHE (Germany)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Raul Sanchez - ELFAC (Spain)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Mo Adefeso-Olateji - TEP (Nigeria)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Fiona Beermier - Ngala (Australia)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Maria del Rosario Esteinou - CIESAS (Mexico)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Caroline Hoglund - Haro (Sweden)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Humoud Alqashan - Kuwait University (Kuwait)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Jose Eduardo Stropoli - UNINOVE (Brazil)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name:
          "Lee Wee Min- Focus on the Family Asia (Malaysia, China, Indonesia)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],

    Funding: [
      {
        name:
          "Wheatley Institution (project partners: ELFAC, IFHE, TEP, HARO, ICS-SP)",
        type: "External",
      },
    ],
    Type: ["Social Progress"],
    Entity: ["CPP"],
    StartDate: "2020",
    EndDate: "2021",
    title:
      "Wheatley Institution (project partners: ELFAC, IFHE, TEP, HARO, ICS-SP)",
    ContentShort: [
      "There is no question that though health workers have been in the frontline of dealing with Covid-19, all of us have been seeing action on the “Home Front” during the pandemic. ",
    ],
    ContentFull: [
      "There is no question that though health workers have been in the frontline of dealing with Covid-19, all of us have been seeing action on the “Home Front” during the pandemic. Especially families, where parents have been managing the care and education of children while juggling the new demands of working from home and concerns for older relatives. The impact on families and on the physical and mental health of parents has been the source of much anecdotal comment and speculation.",
      "The Impact of the Pandemic on Family Life Across Cultures”, one of the largest studies of its kind in the world, was conducted in 72 countries from North America, Latin America, Africa, Europe, Asia, Oceania, and the Middle East and North Africa, in partnership with the United Nations Department of Economic and Social Development, 10 universities and research centers, and 17 NGOs. The global data provided a unique window into the commonalities and differences in how families both shaped and were shaped by the COVID-19 pandemic on every continent, across all income and education levels, and within all age groups. Topics ranged from parents and child health and anxieties, marital relationship quality, parenting practices, gender roles, fatherhood, family coping and resilience, family satisfaction, domestic violence, intergenerational solidarity, impact of technology and internet addiction, social interactions to family policies. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n20.png?2",
      gallery: [],
    id: "20",
    tags: [
      { name: "CPP", link: "https://www.hbku.edu.qa/en/cpp" },
      { name: "Public Health Policy ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Andreas Rechkemmer",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/andreas_sm.jpg?2",
        designation: "Professor",
        college: [{name:"College of Public Policy", link:'https://www.hbku.edu.qa/en/cpp'}],
        link: "https://www.hbku.edu.qa/en/cpp/staff/andreas-rechkemmer",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Anis Ben Brik",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/dr_anis.jpg?2",
        designation: "Associate Professor",
        college: [{name:"College of Public Policy", link:'https://www.hbku.edu.qa/en/cpp'}],
        link: "https://www.hbku.edu.qa/en/cpp/staff/dr-anis-ben-brik",
      },
      {
        name: "Dr. Ozcan Ozturk - CPP",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/1-_ozcan_ozturk.jpg?2",
        designation: "Assistant Professor of Economics",
        college: [{name:"College of Public Policy", link:'https://www.hbku.edu.qa/en/cpp'}],
        link: "https://www.hbku.edu.qa/en/cpp/staff/ozcan-ozturk",
      },
      {
        name: "Dr. Leslie Pal - CPP",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/1-_cpp_dean_-_dr._leslie_a._pal.jpg?2",
        designation: "Dean",
        college: [{name:"College of Public Policy", link:'https://www.hbku.edu.qa/en/cpp'}],
        link: "https://www.hbku.edu.qa/en/cpp/staff/leslie-pal",
      },
    ],

    Funding: [{ name: "QNRF (RRC)", type: "External" }],
    Type: ["Social Progress"],
    Entity: ["CPP"],
    StartDate: "May-16",
    EndDate: "Sep-20",
    title: "COVID-19 Policy Tracker: MENA Government Responses to the Crisis",
    ContentShort: [
      "The research project’s overall aim is to improve the effectiveness and intensity of government policy action during the pandemic.",
    ],
    ContentFull: [
      "The research project’s overall aim is to improve the effectiveness and intensity of government policy action during the pandemic. The outcome is an evidence-based decision support toolkit for the Qatari government with regards to policy measures and instruments to tackle the COVID-19 pandemic. The project’s objectives were to: (1) produce a comprehensive quantitative and qualitative dataset of government policy responses and measures in 10 selected countries of the MENA region (Morocco, Egypt, Jordan, Lebanon, and the 6 GCC states) to the pandemic, to allow for cross-country comparison; (2) produce data analytics in the form of graphs, charts, and interactive visualizations to enhance insight into the complex nature of governmental crisis response measures and to produce comparative policy analysis; (3) inform and support Qatari and regional government policy analysis and decision-making by providing a reliable data and knowledge base of COVID-19 policy interventions in the region.",
      "We developed a comprehensive dataset template and focused our data collection methodology on three main areas of government response to the pandemic: public health interventions, economic and finance interventions, and social policy interventions. For each of these areas we identified subcategories of policy measures and interventions. We rigorously collected qualitative and quantitative data for policy interventions in each area and subcategory for each country, by harvesting data from official inter-governmental bulletins and datasets, official government bulletins, announcements and websites, trusted news sources traced back to official sources, policy briefs and documents, and academic publications.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n21.png?2",
      gallery: [
              {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturerv1.png?2"},
              {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturerv21.png?2"},
              {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturerv31.png?2"},
              {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturerv41.png?2"},
              {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturerv51.png?2"},
              {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturerv61.png?2"},
              {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturerv71.png?2"},
             
      ],
    id: "21",
    tags: [
      { name: "CSE", link: "https://www.hbku.edu.qa/en/cse" },
      { name: "Health ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Amine Bermak",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/3-_dr._amine_bermak.jpg?2",
        designation: "Professor and Associate Dean",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/dr-amine-bermak",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Jinho Bae - JNU (South Korea)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Chi Ying Tsui - HKUST (Hong Kong)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Bo Wang - HBKU",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/1-_bo_wang.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/bo-wang",
      },
    ],

    Funding: [{ name: "QNRF- NPRP11S", type: "External" }],
    Type: ["Artificial Intelligence"],
    Entity: ["CSE"],
    StartDate: "May-19",
    EndDate: "Sep-21",
    title:
      "Low Cost Wearable Self-Powered Wireless Sensors Network for real-time human activity and health monitoring",
    ContentShort: [
      "Wearable self-powered sensors (WSPS) are believed to be the next technological boom with a very wide application range of applications where real time activity and health monitoring are required including construction industry, biomedical applications, military and sport applications.",
    ],
    ContentFull: [
      "Wearable self-powered sensors (WSPS) are believed to be the next technological boom with a very wide application range of applications where real time activity and health monitoring are required including construction industry, biomedical applications, military and sport applications. The aim of this project is to develop a wearable robust multi-sensing self-powered platform based on low cost printed electronics technology combined with CMOS wireless connectivity. The Sensors will be implemented on flexible wearable substrates and fabricated through printed electronics technology, which can be interfaced with human skin without any interfacing medium (impedance matching). Novel encapsulation techniques and coating tools will be proposed in order to protect the sensor from humidity and direct contact with the skin. The sensor array enables to monitor real time data such as temperature, fatigue, dehydration, glucose, heartbeat. The sensors’ data will be then transmitted wirelessly using a Bluetooth module to the smart phone and again sent wirelessly to main server by internet or GSM channel. The project will contribute to the development of the first innovative WSPS made in Qatar. It will have a profound positive image on Qatar cutting-edge research and will place Qatar at a leading world-wide position in wireless sensing industry.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n22.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture176.png?2"},
      ],
    id: "22",
    tags: [
      { name: "CSE", link: "https://www.hbku.edu.qa/en/cse" },
      { name: "Human-computer Interaction", link: "" },
      { name: "Cognitive Science", link: "" },
      { name: "AI ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Dena Al Thani",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/1-_dena_ahmed_s._al_thani.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/dena-ahmed-s-al-thani",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Bilkis Banire - CSE",
        avator: "",
        designation: "",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "",
      },
      {
        name: "Dr. Marwa Qaraqe - CSE",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/1-_marwa_qaraqe.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/marwa-qaraqe",
      },
    ],

    Funding: [{ name: "Internal (CSE)", type: "Internal" }],
    Type: ["Artificial Intelligence", "Precision Medicine"],
    Entity: ["CSE"],
    StartDate: "Sep-17",
    EndDate: "Spring 2022",
    title: "Attentional Model for Children with Autism Spectrum Disorder",
    ContentShort: [
      "Children with Autism Spectrum Disorder exhibit an attentional deficit during learning tasks. Teachers and caregivers need to identify when to give attentional support.",
    ],
    ContentFull: [
      "Children with Autism Spectrum Disorder exhibit an attentional deficit during learning tasks. Teachers and caregivers need to identify when to give attentional support. It is challenging to tell when they are inattentive. This research investigates the attentional behaviors peculiar to children with ASD in order to develop an attentional model. The exploratory study consists of a systematic literature review on attention assessment and semi-structured interviews with 17 experts in the ASD field. In the experimental study, 46 children (ASD n=20) and typically developing (TD n=26) took four different attention tasks. During the experiment, we track their eye and face in real-time. The generated data were preprocessed and fed into Support Vector Machine to classify attention and inattention during learning. We compared the performance of three model types: face-based, gaze-based, and hybrid-based. The analysis of exploratory data revealed that face and eye-tracking are crucial for measuring attention. The experimental data demonstrated the potential of face and eye-tracking for detecting attention and evaluating ASD. This study showed that children with ASD exhibit attentional behavior differently with a unique face and eye-tracking features. These findings stress the direction of model design from traditional one-size-fits-all models to personalized models, especially in children with ASD.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n23.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturegreen1.png?2"},
      ],
    id: "23",
    tags: [
      { name: "CSE", link: "https://www.hbku.edu.qa/en/cse" },
      { name: "Energy", link: "" },
      { name: "Food", link: "" },
      { name: "Water", link: "" },
    ],
    pli: [
      {
        name: "Dr. Gordon Mckay",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/hbk_18166.jpg?2",
        designation: "Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/gordon-mckay",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Hamish Mackey - CSE",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/1-_hamish_mackey.jpg?2",
        designation: "Associate Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/hamish-mackey",
      },
      {
        name: "Dr. Tareq Al-Ansari - CSE",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/4-_tareq_al-ansari.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/tareq-al-ansari",
      },
    ],

    Funding: [{ name: "QNRF- NPRP11S", type: "External" }],
    Type: ["Sustainability"],
    Entity: ["CSE"],
    StartDate: "May-19",
    EndDate: "May-23",
    title:
      "Pyrolysis of Qatar Solid Waste Materials to Produce Agricultural/Landscaping Biochars",
    ContentShort: [
      "The main objective of this project is to provide solutions to food and water security in Qatar leading to the development of Doha as a Smart City and Qatar as a Knowledge Based Society. ",
    ],
    ContentFull: [
      "The main objective of this project is to provide solutions to food and water security in Qatar leading to the development of Doha as a Smart City and Qatar as a Knowledge Based Society. The Target of this project is the use of Qatar solid wastes to drive the project to produce biochars for  agricultural applications. The project will provide a potential inventory and roadmap of wastes generated and wastes applications available in Qatar.",
      "The objective will be achieved by developing a process based on the pyrolysis of solid organic wastes to produce biochars for use in agricultural and landscaping applications. The agricultural applications could include the production of foodstuffs or cattle/horse animal feeds with selected properties in particular water retention/desorption capabilities and/or plant/crop fertiliser/nutrients adsorption/desorption chemicals. A major requirement of the project is to produce these biochars to assist in landscaping for the 2022 Qatar World Cup Football competition. For both applications, these biochars will save considerable amounts of water and provide additional soil conditioning benefits. The biochars will be characterised and assessed to determine the process conditions to produce biochars of optimum quality for crop production. The pyrolysis gases will provide sufficient energy for the pyrolysis process.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n24.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1rrcxray.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturerrc1.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictudfgdgre1.png?2"},
      ],
    id: "24",
    tags: [
      { name: "CSE", link: "https://www.hbku.edu.qa/en/cse" },
      { name: "Health", link: "" },
      { name: "AI", link: "" },
    ],
    pli: [
      {
        name: "Dr. David Yang",
        avator: "https://www.hbku.edu.qa/sites/default/files/staff/3-_david_yin_yang.jpg?2",
        designation: "Associate Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/david-yin-yang",
      },
    ],
    ProjectTeams: [
      {
        name: "Jens Schneider - CSE",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_jens_schneider.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/jens-schneider",
      },
      {
        name: "Mohammad Elhissi - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Sabri Boughborbel - Sidra Medicine",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Shah Kamaly and Yoonas Kalathil - Ooredoo (Qatar Cloud)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    Funding: [{ name: "QNRF RRC", type: "External" }],
    Type: ["Artificial Intelligence"],
    Entity: ["CSE"],
    StartDate: "Jun-20",
    EndDate: "Aug-20",
    title:
      "Predicting and Visualizing COVID-19 Patients’ Future Chest X-Ray Images with Deep Learning",
    ContentShort: [
      "This project aims to build an AI-based system for predicting and visualizing COVID-19 patients’ chest X-ray images. ",
    ],
    ContentFull: [
      "This project aims to build an AI-based system for predicting and visualizing COVID-19 patients’ chest X-ray images. Chest X-ray images are commonly used by medical professionals to access and monitor the health conditions of acute pneumonia (including viral infections caused by COVID-19) patients. However, patients without much background in medicine often find such X-ray images confusing. Specifically, a patient often fails to understand:",
      "(i) which part of the X-ray image shows pneumonia,",
      "(ii) what does the same patient’s X-ray image look like when he/she recovers from the disease, and",
      "(iii) what does the same patient’s X-ray image look like with more advanced pneumonia, in the unfortunate situation that the disease worsens over time.",

      "This project answers the above questions with AI-based visualization of X-ray images, as well as AI-based prediction of future X-ray images. We aim to design and develop not only AI-models and visualization methods, but also end-to-end, easy-to-use solutions running on portable hardware that can be deployed at hospitals and other healthcare facilities. The main method used is style-based image translation and generation, using a generative adversarial network (GAN). The trained model can be either run on a server, or a embedded device such as Nvidia AGX Xavier. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n25.png?2",
      gallery: [
           {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictureqasr1_0.png?2"},
           {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictureqasr3.png?2"},
           {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictureqasr5.png?2"},
           
      ],
    id: "25",
    tags: [
      { name: "CSE", link: "https://www.hbku.edu.qa/en/cse" },
      { name: "Oil", link: "" },
      { name: "Gas", link: "" },
      { name: "Energy", link: "" },
    ],
    pli: [
      {
        name: "Dr. Ahmad Abushaikha",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/1-_ahmad_sami_abushaikha.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/ahmad-sami-abushaikha",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Denis Voskov - Delft University",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Prof. Hamdi Techlepi - Stanford University ",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Dr. Kirill Terekhov - Russian Academy of Sciences ",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    Funding: [{ name: "QNRF-NPRP", type: "External" }],
    Type: ["Sustainability"],
    Entity: ["CSE"],
    StartDate: "Jul-18",
    EndDate: "Jul-22",
    title: "QASR Reservoir Simulator",
    ContentShort: [
      "Here we develop a state-of-the-art oil and gas subsurface reservoir simulation platform with most accurate methods for better estimation of hydrocarbon reserves, development strategies and forecasting.",
    ],
    ContentFull: [
      "Here we develop a state-of-the-art oil and gas subsurface reservoir simulation platform with most accurate methods for better estimation of hydrocarbon reserves, development strategies and forecasting. Such platform can save the oil and gas companies millions/ billions of USD due to decrease in uncertainties in the subsurface characterization and by mitigation the risks in field development strategies. ",

      "The software platform has a high-order spatial discretization in combination with an advanced linearization approach for governing equations describing flow and transport in porous media. Advanced linear and nonlinear solvers, capable of dealing with complex subsurface processes are developed to improve efficiency and robustness of forward simulation.  The combination of these techniques will lead to unique simulation capabilities which can provide more reliable and predictive simulation results.",

      "The software can be applied to the analysis of a wide range of complex subsurface processes including oil and gas production from sandstone and carbonate reservoirs, CO2 injection for Enhanced Oil Recovery (EOR) and sequestration, and water storage in deep subsurface formations.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n26.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturetdf1.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturebg1.png?2"},
      ],
    id: "26",
    tags: [
      { name: "CSE", link: "https://www.hbku.edu.qa/en/cse" },
      { name: "Computer Science", link: "" },
      { name: "Cybersecurity", link: "" },
      { name: "Authentication", link: "" },
    ],
    pli: [
      {
        name: "Dr. Roberto Di Pietro",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_roberto_di_pietro.jpg?2",
        designation: "Full Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/roberto-di-pietro",
      },
    ],
    ProjectTeams: [
      {
        name: "Simone Raponi - CSE",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    Funding: [{ name: "TDF", type: "External" }],
    Type: ["Artificial Intelligence", "Social Progress"],
    Entity: ["CSE"],
    StartDate: "Feb-20",
    EndDate: "Feb-21",
    title: "Strong Server Authentication for Online Transaction",
    ContentShort: [
      "The main objective of this project is to provide solutions to food and water security in Qatar leading to the development of Doha as a Smart City and Qatar as a Knowledge Based Society. ",
    ],
    ContentFull: [
      "The capillary diffusion of Internet services of the last decade has certified the shift of banking services from in-person to online. Nowadays, any bank offers web platforms and mobile applications that allow users to manage their funds online, as well as transfer money to any recipient from their home.",
      "Despite the advantages, the shift of banking services online carries a plethora of security issues. For example, remote attackers could steal legitimate users’ credentials to fully impersonate them on the web.",

      "To face the cited threats, many banking services providers implement Multi-Factor Authentication (MFA) solutions. However, current MFA solutions require the availability of dedicated devices or additional channels. Therefore, when either the dedicated devices or the additional channels are not available, they cannot be adopted. ",

      "We hereby propose a solution that allows enforcing single-channel MFA, relying on general-purpose additional authentication terminals. Our solution is a flexible cryptographic scheme, where a number of devices can be used to prove the authenticity of online transactions, despite the primary authentication terminal triggering the transaction could be compromised. At the same time, our solution requires a limited-effort collaboration by the user, as well as to realize any difference in the values shown by the general-purpose device.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n28.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictureso1.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictureso2.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictureso3.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/pictureso4.jpg?2"},
      ],
    id: "28",
    tags: [
      { name: "QEERI", link: "https://www.hbku.edu.qa/en/qeeri" },
      { name: "Energy", link: "" },
    ],
    pli: [
      {
        name: "Dr. Dunia A. Bachour",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Daniel Astudillo - QEERI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/2-_daniel_perez_astudillo.jpg?2",
        designation: "Scientist",
        college: [{name:"Qatar Environment and Energy Research Institute", link:'https://www.hbku.edu.qa/en/qeeri'}],
        link: "https://www.hbku.edu.qa/en/staff/daniel-perez-astudillo",
      },
      {
        name: "Giovanni Scabbia - QEERI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_giovanni_scabbia.jpg?2",
        designation: "Research Associate",
        college: [{name:"Qatar Environment and Energy Research Institute", link:'https://www.hbku.edu.qa/en/qeeri'}],
        link: "https://www.hbku.edu.qa/en/staff/giovanni-scabbia",
      },
      {
        name: "Dr. Antonio Sanfilippo - QEERI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/antonio_sanfilippo.jpg?2",
        designation: "Chief Scientist",
        college: [{name:"Qatar Environment and Energy Research Institute", link:'https://www.hbku.edu.qa/en/qeeri'}],
        link: "https://www.hbku.edu.qa/en/staff/sanfilippo-antonio",
      },
    ],
    Funding: [{ name: "Internal (QEERI)", type: "Internal" }],
    Type: ["Sustainability"],
    Entity: ["QEERI"],
    StartDate: "2016",
    EndDate: "Ongoing",
    title: "Solar Radiation Monitoring Network in Qatar",
    ContentShort: [
      "In collaboration with the Qatar Meteorology Department QMD, QEERI operates a network of 13 high-quality solar radiation monitoring stations across Qatar that continuously measure the solar radiation components at the ground level",
    ],
    ContentFull: [
      "In collaboration with the Qatar Meteorology Department QMD, QEERI operates a network of 13 high-quality solar radiation monitoring stations across Qatar that continuously measure the solar radiation components at the ground level: DNI, GHI, DHI. The meteorological parameters are monitored by the AWS stations from QMD including the following parameters: air temperature (T), atmospheric air pressure (P), relative humidity (RH), wind speed and wind direction. In addition, the ultraviolet radiation (UV) and long wave downward radiation are measured at two of the sites (Al Shahaniya and Sudanthile). The detailed solar resources information at the 13 sites in Qatar help to determine the solar potential throughout the country in a very accurate way and will help consequently to deploy solar energy projects in Qatar.",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n29.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1001.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1.002png.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1003.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1004.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1005.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1006.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1007.png?2"},
      ],
    id: "29",
    tags: [
      { name: "QEERI", link: "https://www.hbku.edu.qa/en/qeeri" },
      { name: "Sustainability", link: "" },
      { name: "Water", link: "" },
      { name: "Environment", link: "" },
    ],
    pli: [
      {
        name: "Dr. Abdelnasser Aboukhlewa",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/abdel_nasser_qeeri-2.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Environment and Energy Research Institute", link:'https://www.hbku.edu.qa/en/qeeri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-abdelnasser-aboukhlewa",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Igor Krupa - CAM, QU",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Prof. Ahmed Abdala - TAMUQ",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Prof. Hans-Jorg Bart - Kaiserslautern University (Germany)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Prof. Muammer Koc - CSE",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_muammer_koc.jpg?2",
        designation: "Founding Professor and Head of Sustainability Division",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/muammer-koc",
      },
    ],
    Funding: [{ name: "QNRF NPRP10 HBKU Innovation Center", type: "External" }],
    Type: ["Sustainability"],
    Entity: ["QEERI"],
    StartDate: "2018",
    EndDate: "2025",
    title: "Advanced MED Technology for Solar Seawater Desalination",
    ContentShort: [
      "97% of the water in Qatar is produced by desalination, indicating that not only is water security the grandest challenge but also that desalination is a sustainable solution. ",
    ],
    ContentFull: [
      "97% of the water in Qatar is produced by desalination, indicating that not only is water security the grandest challenge but also that desalination is a sustainable solution. The harsh gulf seawater characteristics - high salinity, high temperature, high turbidity and impurities, high boron levels - mean that thermal desalination is the most reliable technology, not suffering from the quality and fouling issues associated with membrane based desalination technologies. However, the energy consumption of thermal desalination can be more than twice that of membrane desalination using reverse osmosis.",
      "In this project, we are making significant improvements to the MED process in order to reduce energy consumption and environmental impact. In addition to novel changes to the MED process itself, we are evaluating the required chemicals for the process (antiscalant and wettability agents) and thermal polymer plate/tubes instead of metal tubes. The project eventually aims to evaluate the use of solar energy to power MED for desalination and brine treatment technology. Successful engagement and a signed 20-year agreement with the key national stakeholder (Qatar Electricity and Water Company, QEWC) as well as international academic and industry collaboration, promises advanced MED technology development as a potential solution for reducing energy consumption and reducing water unit cost.  ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n30.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1sars.jpg?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1sars2.png?2"},
      ],
    id: "30",
    tags: [
      { name: "QEERI", link: "https://www.hbku.edu.qa/en/qeeri" },
      { name: "Environment", link: "" },
      { name: "Health", link: "" },
    ],
    pli: [
      {
        name: "Dr. Khaled Mahmoud",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/2-_khaled_mahmoud.jpg?2",
        designation: "Senior Scientist",
        college: [{name:"Qatar Environment and Energy Research Institute", link:'https://www.hbku.edu.qa/en/qeeri'}],
        link: "https://www.hbku.edu.qa/en/staff/khaled-mahmoud",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Jenny Lawler - QEERI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/3-_jenny_lawler.jpg?2",
        designation: "Senior Research Director",
        college: [{name:"Qatar Environment and Energy Research Institute", link:'https://www.hbku.edu.qa/en/qeeri'}],
        link: "https://www.hbku.edu.qa/en/staff/jenny-lawler",
      },
      {
        name: "Dr. Joel Malek - WCMQ",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    Funding: [{ name: "Internal (QEERI)", type: "Internal" }],
    Type: ["Precision Medicine"],
    Entity: ["QEERI"],
    StartDate: "Sep-20",
    EndDate: "TBD",
    title: "COVID-19 (SARS-CoV-2) Monitoring Wastewater in Qatar",
    ContentShort: [
      "QEERI is leading a national priority project to monitor COVID-19 (SARS-CoV-2) in municipal wastewater, in collaboration with the Public Works Authority (Ashghal), Weill-Cornell Medicine-Qatar (WCM-Q), and Hamad Medical Corporation (HMC). ",
    ],
    ContentFull: [
      "QEERI is leading a national priority project to monitor COVID-19 (SARS-CoV-2) in municipal wastewater, in collaboration with the Public Works Authority (Ashghal), Weill-Cornell Medicine-Qatar (WCM-Q), and Hamad Medical Corporation (HMC). The initiative forms part of the environmental testing pilot program launched by the Scientific Reference and Research Task Force (SSRTF) of the Ministry of Public Health (MoPH), which was established in response to the COVID-19 pandemic to provide scientific evidence to Qatar’s policymakers for data-based decision making. ",
      "SARS-CoV-2 viral RNA was detected in samples from all tested Wastewater Treatment Plants (WWTPs) across a twelve week period (Jun–Aug 2020), during the decline phase of the first peak of the pandemic. A very clear trend matching the decay in reported clinical cases by MoPH was observed. ",
      "A wastewater based epidemiological (WBE) model was developed to relate the SARS-CoV-2 RNA found in the wastewater samples to the number of infected people in the population. This model was able to capture well the diagnosis ratio of approximately 10% observed via antibody testing in the clinically reported cases. ",
      "QEERI is currently working with the MoPH to develop regular surveillance of (SARS-CoV-2) at the national level in the sewage system across Qatar. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n31.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/screen_shot_2021-05-24_at_1.48.56_pm.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/screen_shot_2021-05-24_at_1.49.00_pm.png?2"},
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/screen_shot_2021-05-24_at_1.49.03_pm.png?2"},
         
     
          
      ],
    id: "31",
    tags: [
      { name: "QCRI", link: "https://www.hbku.edu.qa/en/qcri" },
      { name: "Health ", link: "" },
    ],
    pli: [
      {
        name: "Dr. Faisal Farooq",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    ProjectTeams: [
      {
        name: "Prof. Abou Samra - HMC",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    Funding: [{ name: "QNRF", type: "External" }],
    Type: ["Artificial Intelligence", "Precision Medicine"],
    Entity: ["QCRI"],
    StartDate: "Jan-19",
    EndDate: "Ongoing",
    title:
      "Lifestyle Analytics leveraging Wearable Data for Clinical Decision Support",
    ContentShort: [
      "This is a large project consisting of many smaller subprojects that follow a similar theme of utilizing wearable devices that capture activity, glucose levels, heart rate etc.  ",
    ],
    ContentFull: [
      "This is a large project consisting of many smaller subprojects that follow a similar theme of utilizing wearable devices that capture activity, glucose levels, heart rate etc. in clinical decision support. We apply machine learning to wearable datasets both from cohorts in Qatar and open datasets from USA and UK to explore  how to get insights from the wearable data regarding important clinical outcomes. We are conducting research to establish several relationships and to demonstrate that it is possible to develop interventions that can lead to improvements. For example, measurements of activity are predictive of future levels of exercise, sleep pattern and quality, and stress levels. Altering such activity can improve these manifestations which in turn can lead to improvements in the disease outcomes. Machine learning techniques such as recommender systems and just in time interventions using reinforcement learning can learn to identify what changes in activity are most beneficial and what prompting techniques are most effective to get people to adopt those changes. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n32.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picture1qcri0.png?2"},
      ],
    id: "32",
    tags: [
      { name: "QCRI", link: "https://www.hbku.edu.qa/en/qcri" },
      { name: "Cybersecurity", link: "" },
    ],
    pli: [
      {
        name: "Dr. Issa Khalil",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/issa_khalil.png?2",
        designation: "Principal Scientist",
        college: [{name:"Qatar Computing Research Institute", link:'https://www.hbku.edu.qa/en/qcri'}],
        link: "https://www.hbku.edu.qa/en/staff/issa-khalil",
      },
    ],
    ProjectTeams: [
      {
        name: "Ting Yu - QCRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/ting_yu_2.jpg?2",
        designation: "Research Director",
        college: [{name:"Qatar Computing Research Institute", link:'https://www.hbku.edu.qa/en/qcri'}],
        link: "https://www.hbku.edu.qa/en/staff/ting-yu",
      },
      {
        name: "Mohamed Nabeel - QCRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/mohamed_nabeel_2.png?2",
        designation: "Scientist",
        college: [{name:"Qatar Computing Research Institute", link:'https://www.hbku.edu.qa/en/qcri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-mohamed-nabeel",
      },
      {
        name: "Mashael Alsabah - QCRI",
        avator: "",
        designation: "Senior Scientist",
        college: [{name:"Qatar Computing Research Institute", link:'https://www.hbku.edu.qa/en/qcri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-mashael-al-sabah",
      },
      {
        name: "Yazan Boshmaf - QCRI",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/yazan_boshmaf.png?2",
        designation: "Scientist",
        college: [{name:"Qatar Computing Research Institute", link:'https://www.hbku.edu.qa/en/qcri'}],
        link: "https://www.hbku.edu.qa/en/staff/dr-yazan-boshmaf",
      },
      {
        name: "Alen Bohceylan - UITSEC Teknoloji A. S (Turkey)",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Kemal Bircakci - TOBB University of Economics and Technology ",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Hasan Dag - Kadir Has University ",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],
    Funding: [{ name: "QNRF- TUBITAK", type: "External" }],
    Type: ["Artificial Intelligence"],
    Entity: ["QCRI"],
    StartDate: "Mar-19",
    EndDate: "Mar-22",
    title:
      "WARNING: A Defense-in-depth Cyber Intelligence Platform to Defend against Emerging Cyber Attacks ",
    ContentShort: [
      "The goal of this project is to provide defense-in-depth intelligence platform to early detect emerging cyber-attacks such as zero-day threats, Advanced Persistent Threats (APTs) and exploits. ",
    ],
    ContentFull: [
      "The goal of this project is to provide defense-in-depth intelligence platform to early detect emerging cyber-attacks such as zero-day threats, Advanced Persistent Threats (APTs) and exploits.  Many successful cyber-attacks go through a series of stages, called a cyber kill chain, including reconnaissance (e.g., scanning), delivery (e.g., phishing), intrusion (e.g., zero-day attack), command & control, lateral movement, and data exfiltration. Therefore, a defense-in-depth strategy must be adopted, where not only specific techniques are developed targeting each stage in the kill chain, but more importantly a unified platform must be established so that the intelligence from different stages could be integrated and correlated to detect stealthy and low-profile malicious activities in a holistic manner.  Designed as a dynamic, extensible and adaptive cyber intelligence platform, WARNING focuses on detecting and correlating the initial key steps of cyber-attacks, through three innovative research activities: (1) Phishing domain detection, as phishing domains are one of the major attack vectors that facilitate the distribution of malicious contents to users during the delivery stage of the cyber kill chain; (2) Malware detection, as malware is the key means for attackers to compromise user accounts and systems in the intrusion stage of the cyber kill chain; and (3) Malicious network traffic detection to identify and contain attacks which are not contained by the first two layers, as attackers rely on compromised user accounts to further explore a system, identify valuable targets and also constantly communicate with command & control servers to get additional payloads or instructions. In each of the above activities, WARNING includes techniques that advance the state of the art, based on the unique insights and experiences from the industrial and academic partners of the project. ",
    ],
    more: "Read more",
  },
  {
    image: "/uploads/n33.png?2",
      gallery: [
          {imgUrl:"https://www.hbku.edu.qa/sites/default/files/picturenvn1_0.png?2"},
      ],
    id: "33",
    tags: [
      { name: "CSE", link: "https://www.hbku.edu.qa/en/cse" },
      { name: "Sustainability", link: "" },
    ],
    pli: [
      {
        name: "Dr. Tareq Al-Ansari",
        avator:
          "https://www.hbku.edu.qa/sites/default/files/staff/4-_tareq_al-ansari.jpg?2",
        designation: "Assistant Professor",
        college: [{name:"College of Science and Engineering", link:'https://www.hbku.edu.qa/en/cse'}],
        link: "https://www.hbku.edu.qa/en/cse/staff/tareq-al-ansari",
      },
    ],
    ProjectTeams: [
      {
        name: "Dr. Younss Ait Mou - CSE",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
      {
        name: "Sarah Namany - CSE",
        avator: "",
        designation: "",
        college:[],
        link: "",
      },
    ],

    Funding: [
      {
        name: "HBKU Innovation Center and Innovation Coupon",
        type: "Internal",
      },
    ],
    Type: ["Sustainability"],
    Entity: ["CSE"],
    StartDate: "Jul-19",
    EndDate: "Jul-20",
    title: "QKONs",
    ContentShort: [
      "QKONs is a digital waste exchange platform where companies and people benefit from recycling waste. ",
    ],
    ContentFull: [
      "QKONs is a digital waste exchange platform where companies and people benefit from recycling waste. The purpose of the platform is to enhance waste recycling as part of the ‘circular economy’, and allow users to benefit economically from their transactions, whilst reducing environmental impacts. The application enables the waste generators to dispose of their waste in the most convenient and sustainable manner, through providing them with information about the closest and appropriate waste bins and rewarding them for each transaction. It also allows recycling companies to monitor and optimise their waste collection processes by having access to real-life geospatial tracking of the waste, which can enable them to spot areas with high waste generation, and hence increase their recycling capacity.",
    ],
    more: "Read more",
  },
];
